import { render, staticRenderFns } from "./lkuAdvset_cr.1.vue?vue&type=template&id=cb3a1970&"
import script from "./lkuAdvset_cr.1.vue?vue&type=script&lang=js&"
export * from "./lkuAdvset_cr.1.vue?vue&type=script&lang=js&"
import style0 from "./lkuAdvset_cr.1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports